import { render, staticRenderFns } from "./TS-metadata-widget.vue?vue&type=template&id=064e3596"
import script from "./TS-metadata-widget.vue?vue&type=script&lang=js"
export * from "./TS-metadata-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports